import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const handleFAQClick = (question: string, isOpening: boolean) => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('trackCustom', 'FAQInteraction', {
        question: question,
        action: isOpening ? 'opened' : 'closed'
      });
      console.log(`✅ FAQ ${isOpening ? 'opened' : 'closed'}: ${question}`);
    }
  } catch (error) {
    console.error('❌ Error tracking FAQ click:', error);
  }
};
export function FAQ() {
  const faqs = [{
    question: '¿Y si mi peque no sabe leer?',
    answer: 'Los tableros usan iconos; no hace falta leer.'
  }, {
    question: '¿Funciona con 2 o más hijos?',
    answer: 'Sí: un tablero por niño o colores por niño en el mismo tablero.'
  }, {
    question: '¿Y si nos vamos de viaje?',
    answer: 'Imprime en mini o llévalo en el móvil; la secuencia visual es la clave.'
  }, {
    question: '¿Y si tenemos TEA/TDAH?',
    answer: 'La anticipación visual y pasos concretos suele ayudar; adapta el ritmo.'
  }, {
    question: '¿Estos libros me llegan impresos? ¿O cómo los recibo?',
    answer: 'Es normal preguntarlo… Pero algo dentro de ti ya puede sentir el alivio de recibirlos al instante. Este sistema es 100% digital, para que puedas: Acceder desde tu celular, tablet o computadora. Imprimir solo lo que necesites (tarjetas, rutinas, checklists). Empezar hoy mismo sin esperas. Sin envíos. Sin complicaciones. Solo clic, descarga… y transforma.'
  }, {
    question: '¿Puedo pagar con mi tarjeta, Apple Pay o algo más?',
    answer: 'Sí. La plataforma está integrada con Shopify Payments, lo que significa que puedes pagar con: Tarjeta de crédito o débito, Apple Pay, Google Pay y otros métodos seguros, según tu país. Todo está protegido con cifrado SSL y sistemas de seguridad de nivel bancario. Tu acceso se activa automáticamente al completar el pago. Así de fácil. Así de rápido. Así de seguro. Porque si vas a transformar tus días… Que sea sin estrés desde el primer clic.'
  }, {
    question: '¿Y si no me llega el libro después de pagar?',
    answer: 'Es completamente natural que quieras asegurarte… Pero puedes estar tranquila. Apenas confirmes tu pago, recibirás un email con el acceso instantáneo a los tres ebooks. Si por alguna razón no lo ves en tu bandeja principal, revisa tu carpeta de promociones o spam. Y si aún así no aparece… Solo escribe a: globalbooksmkt@gmail.com Y alguien de nuestro equipo te ayudará rápido y con gusto. Tu tranquilidad es parte de esta experiencia. Porque lo importante no es solo comprar, es sentir que estás acompañada.'
  }];
  const [openIndex, setOpenIndex] = useState(0);
  return <section className="py-12 bg-amber-50" id="faq" data-id="element-71">
      <div className="container mx-auto px-4 md:px-6" data-id="element-72">
        <div className="max-w-3xl mx-auto" data-id="element-73">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-900 mb-8 font-serif text-center" data-id="element-74">
            Preguntas frecuentes
          </h2>
          <div className="space-y-4" data-id="element-75">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-amber-100 overflow-hidden" data-id="element-76">
                <button className="w-full px-6 py-4 flex justify-between items-center text-left" onClick={() => {
              const willOpen = openIndex !== index;
              setOpenIndex(openIndex === index ? -1 : index);
              handleFAQClick(faq.question, willOpen);
            }} data-id="element-77">
                  <span className="font-medium text-amber-900" data-id="element-78">
                    {faq.question}
                  </span>
                  {openIndex === index ? <ChevronUp className="text-amber-700" size={20} data-id="element-79" /> : <ChevronDown className="text-amber-700" size={20} data-id="element-80" />}
                </button>
                {openIndex === index && <div className="px-6 pb-4" data-id="element-81">
                    <p className="text-amber-800" data-id="element-82">{faq.answer}</p>
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}